const SeparationReasons = [
  { value: "RESIGNATION", label: "Resignation (Voluntary)" },
  { value: "TERMINATION", label: "Termination (Involuntary)" },
  { value: "RETIREMENT", label: "Retirement" },
  { value: "PERFORMANCE_RELATED", label: "Performance Related" },
  { value: "MISCONDUCT", label: "Misconduct" },
  { value: "PERMANENT_DISABILITY", label: "Permanent Disability" },
  { value: "DEATH", label: "Death" },
  { value: "ABANDONMENT", label: "Abandonment" },
];

export default SeparationReasons;
